import { Injectable } from '@angular/core';
import { CloudinaryOptions } from './cloudinary-options.class';
import { CloudinaryTransforms } from './cloudinary-transforms.class';

const CLOUDINARY_URL: string = 'https://res.cloudinary.com/';


export class CloudinaryImageService {

    getImageUrl(publicId: string, cloudName: string, resourceType: string, type: string, transforms: CloudinaryTransforms): string {
        return  CLOUDINARY_URL +
            cloudName + '/' +
            resourceType + '/' +
            type + '/' +
            transforms.toUrlSegment() +
            publicId + '.' + (transforms.format || 'jpg');

    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
